export default __webpack_public_path__ + "static/media/available-student-lesson.f1822c1b.svg";